<div class="product-base-info" *ngIf="product">
  <div class="image__thumbnail">
    <img alt="{{ getProductName() }}" [src]="getProductImage()"/>
  </div>
  <h6 class="product-base-info__title">{{ getProductName() }}</h6>
</div>
